<template>
  <div>
    <div @click.prevent="listExercises(group)" v-if="!detectMobile()">
      <span class="info-box-icon">
        <i class="fa fa-graduation-cap "></i>
      </span>
      <div class="info-box-content">
        <h3 class="info-box-number" :style="hideProgress ? 'margin-top: 5px' : ''">
          <div :id="'dropdown-'+jIndeks" class="dropdown pull-right" :style="hideProgress ? 'margin-top: -5px' : ''">
            <button v-if="!group.isEnrolled" :id="'dropdownMenuButton-'+jIndeks" class="btn btn-secondary dropdownMenuButton"
            @click.prevent.stop="joinYear(group)">
              <span style="color: black;">{{$t('pages.group.joinGroup')}}</span>
              <!-- <span class="fa fa-plus" style="margin-right: 0 !important;"></span> -->
            </button>
            <button :id="'dropdownMenuButton-'+jIndeks" aria-haspopup="true" aria-expanded="false" data-toggle="dropdown" class="btn btn-secondary dropdown-toggle dropdownMenuButton"
            @click.prevent.stop="toggleDropdown(jIndeks,groupListLength)" v-if="jeAdmin || group.enrollmentId">
              <span class="fa fa-cog"></span>
              <span class="caret"></span>
            </button>
            <div role="menu" :id="group.groupId" class="dropdown-menu">
              <!--<li v-if="!group.isEnrolled">-->
                <!--<a @click.prevent.stop="joinYear(group)">{{$t('pages.group.joinMsg')}}</a>-->
              <!--</li>-->
              <li v-if="jeAdmin">
                <a @click.prevent.stop="editGroup(group)">{{$t('pages.adminpanel.group.editGroup')}}</a>
              </li>
              <li v-if="jeAdmin">
                <a @click.prevent.stop="editYear(group)">{{$t('pages.adminpanel.group.editYear')}}</a>
              </li>
              <li v-if="jeAdmin">
                <a @click.prevent.stop="createYear(group)">{{$t('pages.adminpanel.group.createYear')}}</a>
              </li>
              <li v-if="group.enrollmentId">
                <a @click.prevent.stop="disEnroll(group)">{{$t('pages.group.leaveGroup')}}</a>
              </li>
            </div>
          </div>
          {{ group.groupName | pickTranslation}}
          <span v-if="showYear"> ({{group.yearName}})</span>
          <div v-if="group.isOwner" class="badge bg-blue">{{$t('pages.group.owner')}}</div>
          <div v-if="group.isEnrolled" class="badge bg-green">{{$t('pages.group.enrolled')}}</div>
          <div v-if="group.isPending" class="badge bg-red">{{$t('pages.group.pending')}}</div>
          <div v-if="group.isArchived" class="badge bg-black">{{$t('pages.group.archived')}}</div>
        </h3>
        <div class="progress" v-if="!hideProgress">
          <div class="progress-bar" :style="{width: (group.solvedSubgroupsCount / group.subgroupsCount)*100 + '%'}"></div>
        </div>
        <span class="progress-description">
          {{ group.groupDescription | pickTranslation }}
        </span>
      </div>
    </div>
    <div @click.prevent="listExercises(group)" v-else>
      <div style="padding: 10px">
        <h3 class="small-margin-text info-box-number small-title">
          <div :id="'dropdown-'+jIndeks" class="dropdown pull-right">
            <button v-if="!group.isEnrolled" :id="'dropdownMenuButton-'+jIndeks" class="btn btn-secondary btn-sm dropdownMenuButton"
                    @click.prevent.stop="joinYear(group)"
                    :title="$t('pages.group.joinGroup')">
              <span class="fa fa-plus" style="margin-right: 0 !important;"></span>
            </button>
            <button :id="'dropdownMenuButton-'+jIndeks" aria-haspopup="true" aria-expanded="false" data-toggle="dropdown" class="btn btn-secondary dropdown-toggle btn-sm dropdownMenuButton"
              @click.prevent.stop="toggleDropdown(jIndeks,groupListLength)" v-if="jeAdmin || group.enrollmentId">
              <span class="fa fa-cog"></span>
              <span class="caret"></span>
            </button>
            <div role="menu" :id="group.groupId" class="dropdown-menu">
              <li v-if="group.enrollmentId">
                <a @click.prevent.stop="disEnroll(group)">{{$t('pages.group.leaveGroup')}}</a>
              </li>
              <!--<li v-if="!group.isEnrolled">-->
                <!--<a @click.prevent.stop="joinYear(group)">{{$t('pages.group.joinMsg')}}</a>-->
              <!--</li>-->
              <li v-if="jeAdmin">
                <a @click.prevent.stop="editGroup(group)">{{$t('pages.adminpanel.group.editGroup')}}</a>
              </li>
              <li v-if="jeAdmin">
                <a @click.prevent.stop="editYear(group)">{{$t('pages.adminpanel.group.editYear')}}</a>
              </li>
              <li v-if="jeAdmin">
                <a @click.prevent.stop="createYear(group)">{{$t('pages.adminpanel.group.createYear')}}</a>
              </li>
            </div>
          </div>
          {{ group.groupName | pickTranslation}}
          <span v-if="showYear"> ({{group.yearName}})</span>
          <!-- <div v-if="group.isOwner" class="badge bg-blue">{{$t('pages.group.owner')}}</div>
          <div v-if="group.isEnrolled" class="badge bg-green">{{$t('pages.group.enrolled')}}</div>
          <div v-if="group.isPending" class="badge bg-red">{{$t('pages.group.pending')}}</div>
          <div v-if="group.isArchived" class="badge bg-black">{{$t('pages.group.archived')}}</div> -->
        </h3>
        <div class="progress" v-if="!hideProgress">
          <div class="progress-bar" :style="{width: (group.solvedSubgroupsCount / group.subgroupsCount)*100 + '%'}"></div>
        </div>
        <span class="small-margin-text progress-description" :style="hideProgress ? 'margin-top: 5px' : ''">
          {{ group.groupDescription | pickTranslation }}
        </span>
      </div>
    </div>
    <div class="modal modal-danger fade" id="modal-await" style="display: none;">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span></button>
            <h4 class="modal-title">{{$t("pages.group.await")}}</h4>
          </div>
          <div class="modal-body">
            <p>
              {{$t("pages.group.awaitModalOne")}}
              {{$t("pages.group.awaitModalTwo")}}
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline" data-dismiss="modal">Close</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>

<script>
import router from '@/router/router'
import { mapState, mapGetters } from 'vuex'
import Rest from './../../services/rest'

export default {
  props: ['group', 'jIndeks', 'groupListLength', 'showYear', 'hideProgress'],
  created () {
    // this.$store.dispatch('getGroupsNew')
    this.$store.commit('updateSelectedGroupId', null)
  },
  computed: {
    ...mapState({
      groupList: state => state.groupList,
      currUser: state => state.userData,
      defaultGColor: state => state.defaultGColor
    }),
    ...mapGetters({
      jeAdmin: 'hasAdminRole'
    }),
    anyGroupsIamNotIn () {
      return this.groupList.otherGroups.length > 0
    },
    adminView () {
      return this.$route.meta.admin
    }
  },
  components: {
  },
  methods: {
    detectMobile () {
      if (navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i)) {
        return true
      } else {
        return false
      }
    },
    listExercises (group) {
      if (group.isEnrolled && !group.isPending) {
        this.$store.commit('updateSelectedGroupId', group.groupId)
        if (this.adminView) {
          router.push({name: 'admin', params: {gid: group.groupId, yid: group.yearId, sid: 'root'}})
        } else {
          router.push({name: 'exercises', params: {gid: group.groupId, yid: group.yearId, sid: 'root'}})
        }
      } else if (group.isEnrolled) {
        window.jQuery('#modal-await').modal('toggle')
      }
    },
    disEnroll (group) {
      // CONTSTRAINT if user can be enrolled to max one group
      this.closeAllDropdowns(this.groupListLength)
      let enrollmentId = group.enrollmentId
      Rest.request('DELETE', `/enrollment/${enrollmentId}`).then(() => {
        this.$set(group, 'isEnrolled', false)
        this.$store.dispatch('getGroupsNew')
      }).catch((err) => {
        console.log(err)
      })
    },
    editGroup (group) {
      this.closeAllDropdowns(this.groupListLength)
      this.$set(group, 'showEditYear', false)
      this.$set(group, 'showCreateYear', false)
      this.$store.dispatch('getGroup', {
        gid: group.groupId,
        yid: group.yearId,
        sid: 'root'
      }).then(() => {
        this.$set(group, 'showEdit', !group.showEdit)
      })
    },
    editYear (group) {
      this.closeAllDropdowns(this.groupListLength)
      this.$set(group, 'showEdit', false)
      this.$set(group, 'showCreateYear', false)
      this.$set(group, 'showEditYear', !group.showEditYear)
    },
    createYear (group) {
      this.closeAllDropdowns(this.groupListLength)
      this.$set(group, 'showEditYear', false)
      this.$set(group, 'showEdit', false)
      this.$set(group, 'showCreateYear', !group.showCreateYear)
    },
    getYears (yearId) {
      window.jQuery('.dropdown-toggle').dropdown()
    },
    ChoseYear (group, yearId) {
      group.latestYearId = yearId
    },
    toggleDropdown (index, numberOfElements) {
      // window.jQuery('.dropdown-toggle').dropdown()
      if (window.jQuery('#dropdown-' + index).hasClass('open')) {
        window.jQuery('#dropdownMenuButton-' + index).attr('aria-expanded', false)
        window.jQuery('#dropdown-' + index).removeClass('open')
      } else {
        // zapiranje vseh ostalih popupov
        this.closeAllDropdowns(numberOfElements)
        window.jQuery('#dropdownMenuButton-' + index).attr('aria-expanded', true)
        window.jQuery('#dropdown-' + index).addClass('open')
      }
    },
    closeAllDropdowns (numberOfElements) {
      for (var i = 0; i < numberOfElements; i++) {
        window.jQuery('#dropdownMenuButton-' + i).attr('aria-expanded', false)
        window.jQuery('#dropdown-' + i).removeClass('open')
      }
    },
    getNumberOfVisibleYears (years) {
      return 1
      // return years.filter(function (obj) {
      //   return obj.visible
      // }).length
    },
    joinYear (grupa) {
      this.closeAllDropdowns(this.groupListLength)
      let tren = this
      let fn = async () => { // async wrapper
        try {
          if (grupa.requiredFields !== null) {
            let potrebenVpis = false
            for (let requiredField of grupa.requiredFields) {
              if (tren.currUser[requiredField] == null) {
                potrebenVpis = true
              }
            }
            if (potrebenVpis) {
              this.$store.commit('updateSelectedGroup', grupa)
              window.jQuery('#modal-edit-required-fields').modal('toggle')
              return
            }
          }
          let postdata = {
            yearId: grupa.yearId
          }
          await Rest.request('POST', '/enrollment', postdata).then(() => {
            this.$set(grupa, 'isEnrolled', true)
            this.$store.dispatch('getGroupsNew')
          })
        } catch (error) {
          console.log(error)
        }
      }
      fn()
    }
  },
  mounted () {
  }
}

</script>

<style scoped>
.fa-plus, .fa-wrench {
  color: black;
}
.fa-cog, .caret {
  color: black;
}
.fa-plus, .fa-cog {
  margin-right: 1ex;
}
.group-box {
  cursor: pointer;
}
.dropdownMenuButton {
  background-color:white;
}
.info-box-number {
  text-overflow: ellipsis;
  /* overflow: hidden; TODO: if uncommentedn gear buttons do not work */
}
.small-title {
  font-size: 25px;
}
.small-margin-text {
  margin-top: 0px;
  margin-bottom: 0px;
}
.no-padding-box {
  padding: 0px;
  padding-left: 0px;
  min-height: 70px;
}
</style>



// WEBPACK FOOTER //
// GroupTemplate.vue?596dc12a